import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Scenario } from '../../types/scenario-modeling.types';
import { useAppQuery } from '../use-app-query.hook';

export const useScenario = ({ scenarioId }: { scenarioId: string }) => {
  const queryClient = useQueryClient();
  const {
    data: scenario,
    isFetching,
    isLoading,
    isPending,
  } = useAppQuery<Scenario>({
    queryKey: [QueryKey.GET_SCENARIO, scenarioId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId],
      }),
    enabled: !!scenarioId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SCENARIO] });
  }, [queryClient]);

  const isScenarioLoading =
    Boolean(scenarioId) && !scenario && (isPending || isFetching || isLoading);

  return {
    invalidateQuery,
    scenario,
    isLoading: isScenarioLoading,
  };
};
